import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CrSortingService {

  constructor() { }

  checkNumber(num) {
    if (num == "1" || num == "2" || num == "3" || num == "4" || num == "5" || num == "6" || num == "7" || num == "8" || num == "9" || num == "0") { return true; }
    else { return false; }
  }

  onlyLetters(str) {
    return /^[a-zA-Z\s]+$/.test(str);
  }

  onlyNumber(str) {
    return /^\d+$/.test(str);
  }

  SortCRbyParagraph(a: any, b: any) {
    if (this.onlyLetters(a.paragraph) && this.onlyLetters(b.paragraph)) {
      return a.paragraph > b.paragraph ? 1 : (a.paragraph == b.paragraph ? 0 : -1);
    }
    else if (!(this.onlyLetters(a.paragraph) && this.onlyLetters(b.paragraph))) {
      if (this.checkNumber(a.paragraph[0]) && this.checkNumber(b.paragraph[0])) {
        if (a.paragraph.includes(".") && b.paragraph.includes(".")) {
          if (a.paragraph.split(".")[0] == b.paragraph.split(".")[0]) {
            return Number(a.paragraph.split(".")[1].match(/\d+/)) - Number(b.paragraph.split(".")[1].match(/\d+/));
          }
          else {
            return Number(a.paragraph.split(".")[0]) - Number(b.paragraph.split(".")[0]);
          }
        }
        else if (a.paragraph.includes(".") && (!b.paragraph.includes("."))) {
          if (a.paragraph.split(".")[0] == b.paragraph) {
            return 1;
          }
          else {
            return a.paragraph.split(".")[0] - b.paragraph;
          }
        }
        else if ((!a.paragraph.includes(".")) && b.paragraph.includes(".")) {
          if (a.paragraph == b.paragraph.split(".")[0]) {
            return -1;
          }
          else {
            return a.paragraph - b.paragraph.split(".")[0];
          }
        }
        else {
          a.paragraph = a.paragraph.replace("(", "").replace(")", "");
          b.paragraph = b.paragraph.replace("(", "").replace(")", "");
          if (this.onlyNumber(a.paragraph[0]) && this.onlyNumber(b.paragraph[0])) {
            if (a.paragraph.match(/\d+/) == b.paragraph.match(/\d+/)) {
              return a.paragraph.replace(/[^A-Za-z]/g, '') > b.paragraph.replace(/[^A-Za-z]/g, '') ? 1 : (a.paragraph.replace(/[^A-Za-z]/g, '') == b.paragraph.replace(/[^A-Za-z]/g, '') ? 0 : -1);
            }
            else {
              return Number(a.paragraph.match(/\d+/)) - Number(b.paragraph.match(/\d+/));
            }
          }
          else if ((!Number(a.paragraph[0])) && Number(b.paragraph[0])) {
            return 1;
          }
          else if (Number(a.paragraph[0]) && (!Number(b.paragraph[0]))) {
            return -1;
          }
          else {
            if (this.onlyLetters(a.paragraph) == this.onlyLetters(b.paragraph)) {
              return Number(a.paragraph.match(/\d+/)) - Number(b.paragraph.match(/\d+/));
            }
            else {
              return a.paragraph.replace(/[^A-Za-z]/g, '') > b.paragraph.replace(/[^A-Za-z]/g, '') ? 1 : (a.paragraph.replace(/[^A-Za-z]/g, '') == b.paragraph.replace(/[^A-Za-z]/g, '') ? 0 : -1);
            }
          }
        }
      }
      else if ((!this.checkNumber(a.paragraph[0])) && this.checkNumber(b.paragraph[0])) {
        return 1;
      }
      else if (this.checkNumber(a.paragraph[0]) && (!this.checkNumber(b.paragraph[0]))) {
        return -1;
      }
      else {
        return a.paragraph.replace(/[^A-Za-z]/g, '') > b.paragraph.replace(/[^A-Za-z]/g, '') ? 1 : ((a.paragraph.replace(/[^A-Za-z]/g, '') == b.paragraph.replace(/[^A-Za-z]/g, '')) ? 0 : -1);
      }
    }
  }

  SortCRbyStandardType(a: any, b: any) {
    return a.standardType > b.standardType ? 1 : (a.standardType == b.standardType ? 0 : -1);
  }

  SortCRbyTopic(a: any, b: any) {
    let spanA = document.createElement("span");
    spanA.innerHTML = a.topic;
    let x = spanA.innerText.trim().toLowerCase();
    let spanB = document.createElement("span");
    spanB.innerHTML = b.topic;
    let y = spanB.innerText.trim().toLowerCase();
    if (x.split("-").length > 2 && a.topic.startsWith("<a")) {
      let subPartsX = x.split("-");
      let subPartsY = y.split("-");
      if (subPartsX[0] == subPartsY[0]) {
        if (subPartsX[1] == subPartsY[1]) {
          if ((this.onlyNumber(subPartsX[2])) && (this.onlyNumber(subPartsY[2]))) {
            if (Number(subPartsX[2]) == Number(subPartsY[2])) {
              if ((this.onlyNumber(subPartsX[3])) && (this.onlyNumber(subPartsY[3]))) {
                return Number(subPartsX[3]) - Number(subPartsY[3]);
              }
              else if ((!this.onlyNumber(subPartsX[3])) && (this.onlyNumber(subPartsY[3]))) {
                if (Number(subPartsX[3].match(/\d+/)) == Number(subPartsY[3].match(/\d+/))) {
                  return 1;
                }
                else { return Number(subPartsX[3].match(/\d+/)) - Number(subPartsY[3].match(/\d+/)); }
              }
              else if ((this.onlyNumber(subPartsX[3])) && (!this.onlyNumber(subPartsY[3]))) {
                if (Number(subPartsX[3].match(/\d+/)) == Number(subPartsY[3].match(/\d+/))) {
                  return -1;
                }
                else { return Number(subPartsX[3].match(/\d+/)) - Number(subPartsY[3].match(/\d+/)); }
              }
              else {
                if (Number(subPartsX[3].match(/\d+/)) == Number(subPartsY[3].match(/\d+/))) {
                  return subPartsX[3].replace(/[^A-Za-z]/g, '') > subPartsY[3].replace(/[^A-Za-z]/g, '') ? 1 : ((subPartsX[3].replace(/[^A-Za-z]/g, '') == subPartsY[3].replace(/[^A-Za-z]/g, '')) ? 0 : -1);
                }
                else {
                  return Number(subPartsX[3].match(/\d+/)) - Number(subPartsY[3].match(/\d+/));
                }
              }
            }
            else {
              return Number(subPartsX[2]) - Number(subPartsY[2]);
            }
          }
          else if ((!this.onlyNumber(subPartsX[2])) && (this.onlyNumber(subPartsY[2]))) {
            return 1;
          }
          else if ((this.onlyNumber(subPartsX[2])) && (!this.onlyNumber(subPartsY[2]))) {
            return -1;
          }
          else {
            return Number(subPartsX[2].match(/\d+/)) - Number(subPartsY[2].match(/\d+/));
          }
        }
        else {
          return Number(subPartsX[1]) - Number(subPartsY[1]);
        }
      }
      else {
        return Number(subPartsX[0]) - Number(subPartsY[0]);
      }
    }
    else {
      return x.replace(/[^A-Za-z]/g, '') > y.replace(/[^A-Za-z]/g, '') ? 1 : ((x.replace(/[^A-Za-z]/g, '') == y.replace(/[^A-Za-z]/g, '')) ? 0 : -1);
    }
  }

  SortCRbyParagraphId(a: any, b: any) {
    let spanA = document.createElement("span");
    spanA.innerHTML = a.paragraphId;
    let x = spanA.innerText.trim().toLowerCase();
    let spanB = document.createElement("span");
    spanB.innerHTML = b.paragraphId;
    let y = spanB.innerText.trim().toLowerCase();
    if (x.split("-").length > 2 && a.paragraphId.startsWith("<a")) {
      let subPartsX = x.split("-");
      let subPartsY = y.split("-");
      if (subPartsX[0] == subPartsY[0]) {
        if (subPartsX[1] == subPartsY[1]) {
          if (((this.onlyNumber(subPartsX[2])) && (this.onlyNumber(subPartsY[2]))) || ((!this.onlyNumber(subPartsX[2])) && (!this.onlyNumber(subPartsY[2])))) {
            if (subPartsX[2] == subPartsY[2]) {
              if ((this.onlyNumber(subPartsX[3])) && (this.onlyNumber(subPartsY[3]))) {
                return Number(subPartsX[3]) - Number(subPartsY[3]);
              }
              else if ((!this.onlyNumber(subPartsX[3])) && (this.onlyNumber(subPartsY[3]))) {
                if (Number(subPartsX[3].match(/\d+/)) == Number(subPartsY[3].match(/\d+/))) {
                  return 1;
                }
                else { return Number(subPartsX[3].match(/\d+/)) - Number(subPartsY[3].match(/\d+/)); }
              }
              else if ((this.onlyNumber(subPartsX[3])) && (!this.onlyNumber(subPartsY[3]))) {
                if (Number(subPartsX[3].match(/\d+/)) == Number(subPartsY[3].match(/\d+/))) {
                  return -1;
                }
                else { return Number(subPartsX[3].match(/\d+/)) - Number(subPartsY[3].match(/\d+/)); }
              }
              else {
                if (Number(subPartsX[3].match(/\d+/)) == Number(subPartsY[3].match(/\d+/))) {
                  return subPartsX[3].replace(/[^A-Za-z]/g, '') > subPartsY[3].replace(/[^A-Za-z]/g, '') ? 1 : ((subPartsX[3].replace(/[^A-Za-z]/g, '') == subPartsY[3].replace(/[^A-Za-z]/g, '')) ? 0 : -1);
                }
                else {
                  return Number(subPartsX[3].match(/\d+/)) - Number(subPartsY[3].match(/\d+/));
                }
              }
            }
            else {
              return Number(subPartsX[2].toLowerCase().replace("s", "")) - Number(subPartsY[2].toLowerCase().replace("s", ""));
            }
          }
          else if ((!this.onlyNumber(subPartsX[2])) && (this.onlyNumber(subPartsY[2]))) {
            return 1;
          }
          else if ((this.onlyNumber(subPartsX[2])) && (!this.onlyNumber(subPartsY[2]))) {
            return -1;
          }
        }
        else {
          return Number(subPartsX[1]) - Number(subPartsY[1]);
        }
      }
      else {
        return Number(subPartsX[0]) - Number(subPartsY[0]);
      }
    }
    else {
      return x.replace(/[^A-Za-z]/g, '') > y.replace(/[^A-Za-z]/g, '') ? 1 : ((x.replace(/[^A-Za-z]/g, '') == y.replace(/[^A-Za-z]/g, '')) ? 0 : -1);
    }
  }
}
